
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.125 12.954v-2.727a.714.714 0 00-.183-.482.6.6 0 00-.442-.2.6.6 0 00-.442.2.714.714 0 00-.183.482v2.727c0 .181-.066.355-.183.483a.6.6 0 01-.442.2H2a.6.6 0 01-.442-.2.715.715 0 01-.183-.482v-2.728a.714.714 0 00-.183-.482.6.6 0 00-.442-.2.6.6 0 00-.442.2.714.714 0 00-.183.482v2.727c0 .543.198 1.063.55 1.447A1.8 1.8 0 002 15h11.25a1.8 1.8 0 001.326-.6c.351-.383.549-.903.549-1.446zm-3.988-3.559l-3.125 2.728a.593.593 0 01-.387.147.593.593 0 01-.388-.147L4.112 9.395a.725.725 0 01-.06-.92.616.616 0 01.392-.249.584.584 0 01.444.106L7 10.172V.683C7 .5 7.066.328 7.183.2a.6.6 0 01.442-.2.6.6 0 01.442.2.715.715 0 01.183.482v9.49l2.113-1.84a.618.618 0 01.219-.147.577.577 0 01.501.04.641.641 0 01.198.178.743.743 0 01.037.792.657.657 0 01-.18.2z","fill":"#F1F5F9"}})])
          )
        }
      }
    